import { action } from "typesafe-actions";
import * as T from "@actionTypes";
import { IAgencyReducer } from "@utils";

export const setAgency = (agencyData: IAgencyReducer) => action(T.SET_AGENCY, agencyData);
